/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 캘린더 다이얼로그
 * 버전 : 1.0
 * 파일명 : DialogFestivalRegister.tsx
 * 작성자 : 강동형
 * 작성일 : 2026-01-13
 * ================================================================
 * 수정일 : 2026-02-04, 축제 등록 기능 연결
 *================================================================*/

import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import RecruitSelectType from './RecruitSelectType'
import DialogDatePickerFestival from './DialogDatePickerFestival'
import { NextButton } from '../common/CommonStyled'
import { postEventInfo } from 'src/api/Recruit'
import { useRecruitStore } from 'src/stores/RecruitStore'
import { format } from 'date-fns'
import { toast } from 'react-toastify'
import { LoadFestival } from './LoadArmyRecruit'

const ComponenetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const InputLabel = styled.span`
  color: #7F7F89;
  font-size: 14px;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 26px;
`

const DialogFestivalRegister = () => {
  const start_date = useRecruitStore(s=>s.dialogStartDate)
  const end_date = useRecruitStore(s=>s.dialogEndDate)
  const setField = useRecruitStore(s=>s.setField)
  const year = useRecruitStore((state)=>state.year)
  const month = useRecruitStore((state)=>state.month)
  const modifyProps = useRecruitStore((state)=>state.modifyProps)
  const reset = useRecruitStore((state)=>state.reset)

  const [name,setName] = useState(modifyProps?.title ?? '')
  const [location,setLocation] = useState(modifyProps?.address ?? '')
  const [urlLink,setUrlLink] = useState(modifyProps?.urlLink ?? '')
  const [resetTrigger,setResetTrigger] = useState(0)
  const [type, setType] = useState(modifyProps?.recruitment_type ?? '축제')

  useEffect(()=>{
    if(modifyProps?.start){
      setField('dialogStartDate',modifyProps.start)
    }
    if(modifyProps?.end){
      setField('dialogEndDate',modifyProps.end)
    }
  },[modifyProps])

  useEffect(()=>{
    return(()=>{
      reset('modifyProps')
    })
  },[])

  const onClickReset = ()=>{
    setResetTrigger(resetTrigger+1)
    setName('')
    setLocation('')
    setUrlLink('')
  }

  const onClickRegister = async () =>{
    if(!start_date || !end_date) {
      toast.error('날짜는 반드시 입력되어야 합니다.')
      return
    }

    const res = await postEventInfo({
        name:name,
        type: type,
        start_Date: format(start_date,'yyyy-MM-dd'),
        end_Date: format(end_date,'yyyy-MM-dd'),
        location: location,
        url: urlLink,
        event_id: modifyProps.announce_id
      })
    if(res.status === 'OK'){
      const response = await LoadFestival({year:Number(year),month:Number(month)});
      setField('ArmyRecruitData', response.data);
      setField('isOpen',false)
      setField('dialogState','축제 정보')
      toast.success('정상적으로 등록되었습니다.')
    }
    else{
      toast.error('위치주소가 유효하지 않습니다.')
    }
  }

  return (
    <ComponenetWrapper>
      <InputWrapper>
        <InputLabel>*유형</InputLabel>
        <RecruitSelectType whichTab='축제 정보' from='축제 등록' resetTrigger={resetTrigger} setTypeProp={setType} typeProp={modifyProps?.recruitment_type ?? '축제'}/>
      </InputWrapper>
      <InputWrapper>
        <InputLabel>*축제명</InputLabel>
        <InputBoxOnChange onChange={(e)=>setName(e.target.value)} value={name} height='46px'/>
      </InputWrapper>
      <InputWrapper>
        <InputLabel>*기간</InputLabel>
        <DialogDatePickerFestival resetTrigger={resetTrigger}/>
      </InputWrapper>
      <InputWrapper>
        <InputLabel>*위치</InputLabel>
        <InputBoxOnChange onChange={(e)=>setLocation(e.target.value)} value={location} height='46px'/>
      </InputWrapper>
      <InputWrapper>
        <InputLabel>*URL</InputLabel>
        <InputBoxOnChange onChange={(e)=>setUrlLink(e.target.value)} value={urlLink} height='46px'/>
      </InputWrapper>
      <ButtonWrapper>
          <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
          <NextButton style={{padding:'10px', height:'46px', boxShadow:'none'}} onClick={onClickRegister}>등록</NextButton>
      </ButtonWrapper>
    </ComponenetWrapper>
  )
}

export default DialogFestivalRegister